import React from 'react';
import styles from './Footer.module.css';
import { ChatDtoEstado } from '@tera/shared/src/dto/ChatDto';
import FooterChatbot from './FooterChatbot';
import { FooterAtendimento } from './FooterAtendimento';
import FooterFinalizado from './FooterFinalizado';
import FooterAguardandoCliente from './FooterAguardandoCliente';
import FooterAguardandoAtendimento from './FooterAguardandoAtendimento';

type FooterProps = {
  estado: ChatDtoEstado;
  onSend: (mensagem: string, anexos: File[]) => void;
  isSending: boolean;
  onSendAudio: (audio: Blob) => void;

  chatId: number;
  /** `chatKey` da conversa aberta, usada para guardar o rascunho. */
  rascunhoKey: string | null;
  onChatAddTag: (chatId: number, tagId: number) => void;
  chatTags?: string[];
  onTyping: (isTyping: boolean) => void;
};
const Footer = ({
  estado,
  onSend,
  isSending,
  onSendAudio,
  chatId,
  rascunhoKey,
  onChatAddTag,
  chatTags,
  onTyping,
}: FooterProps) => {
  switch (estado) {
    case 'chatbot':
      return <FooterChatbot />;
    case 'atendimento':
      return (
        <FooterAtendimento
          chatId={chatId}
          rascunhoKey={rascunhoKey}
          onChatAddTag={onChatAddTag}
          chatTags={chatTags}
          onSend={onSend}
          isSending={isSending}
          onSendAudio={onSendAudio}
          onTyping={onTyping}
        />
      );
    case 'finalizado':
      return <FooterFinalizado />;
    case 'aguardando_cliente':
      return <FooterAguardandoCliente />;
    case 'aguardando_atendente':
      return <FooterAguardandoAtendimento />;
    default:
      return null;
  }
};

export default Footer;
